import { ActionModel } from "./../../model/application/action";
import { UtilityConfig } from "./../action/utility";
import { UtilityThunkService } from "../thunk/utility";
import { APILoaderAction } from "../action/merchant";

export class UtilityConfigStateReducer {
  static Config(state: any = {}, action: ActionModel) {
    switch (action.type) {
      case UtilityConfig.Set_Utility_Config_State:
        return action.payload;
        
        case UtilityConfig.Logout:
        UtilityThunkService.Logout(() => {}, action.payload);
        return action.payload;
      default:
        return state;
    }
  }

  static APILoader(state: any = {}, action: ActionModel) {
    switch (action.type) {
      case APILoaderAction.SET_API_LOADING_STATE:
        return action.payload;
      default:
        return state;
    }
  }
  static SetModal(state: any = {}, action: ActionModel) {
    switch (action.type) {
      case APILoaderAction.SET_MODAL: 
      return action.payload
      default:
        return state;
    }
  }
}

